import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading, null = no auth
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch { /* logout proceeds regardless of network result */ }
    setUser(null);
    window.location.href = "/login";
  }, []);

  const impersonate = useCallback(async (userId) => {
    await api.post(`/auth/impersonate/${userId}`);
    window.location.href = "/dashboard";
  }, []);

  const stopImpersonation = useCallback(async () => {
    await api.post("/auth/stop-impersonation");
    window.location.href = "/tenants";
  }, []);

  const value = useMemo(
    () => ({ user, setUser, loading, checkAuth, logout, impersonate, stopImpersonation }),
    [user, loading, checkAuth, logout, impersonate, stopImpersonation]
  );

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
